// Shared DOM / React event helpers
// Provides a safe wrapper to call native stopImmediatePropagation when available
// without relying on unsafe type assertions scattered across components.
export const safelyStopImmediatePropagation = (evt // eslint-disable-line @typescript-eslint/no-explicit-any
) => {
    try {
        // Always stop React's synthetic propagation first
        if (evt && typeof evt.stopPropagation === "function") {
            evt.stopPropagation();
        }
        // Prevent default if already explicitly requested upstream via flag
        // (Callers can still invoke evt.preventDefault() themselves when needed.)
        const native = evt?.nativeEvent ?? evt;
        if (native && typeof native.stopImmediatePropagation === "function") {
            native.stopImmediatePropagation();
        }
    }
    catch (_) {
        // Silently ignore; defensive to avoid breaking user interaction if browser impl differs
    }
};
